import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';
import Brae2 from '../../img/brae/brae2.jpg'; 

const WalkDryIslandDetails = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity(""));
  }

  return (
    <div className="row">
    <div className="col-12 imagesBackgroundColour">
      <div className="generalText">
        <div className="generalTextBox">
          <p className="activity-back-button">
            <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
          </p>
        </div>
      </div>
    </div>
    <div className="col-12 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <h2 className="walks-section-heading">Dry Island</h2>
            <h3 className="walks-detail-heading"><strong>Directions</strong></h3>
            <p className="walk-text">Head out of the village back towards Glenelg and just before the Brae turn left on a track.  If the tide is not high you can cross 
                                      to Dry Island and explore.  Great viewpoints from either of the 'peaks' and on the far side there is a secluded rocky cove to explore.
                                    In gaelic it is known as Eilean Tioram which as you can probably guess translates to Dry Island.
            </p>                                              
            <h3 className="walks-detail-heading"><strong>Time</strong></h3>
            <p className="walk-text">30 mins there and back.
            </p>                                              
          </div>
        </div>
      </div>
    <div className="col-12 imagesBackgroundColour walk-image">
      <img src={Brae2} alt="View of Arnisdale" className="gallery-image" />
    </div>
    <div className="col-12 imagesBackgroundColour">
      <div className="generalText">
          <div className="generalTextBox">
            <p className="activity-back-button">
              <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
            </p>
          </div>
      </div>
    </div>
    </div>
  );
}

export default WalkDryIslandDetails
